import Theme from 'Theme';
import styled from 'styled-components';
import config from 'config';
import Card from 'components/common/Card';

const BASENAME = config.site.baseName;

export const Container = styled.div`
  display: flex;
  justify-content: center;
`;

export const InnerContainer = styled.div`
  flex: 1;
  max-width: 1600px;
  margin-top: calc(88px + 24px);

  ${(props) => props.theme.media.sm.max`
    width: 100%;
    margin-top: 0px !important;
    padding-left: 0px !important;
    padding-right: 0px !important;
  `}

  ${(props) => props.theme.media.xl.max`
    max-width: 1366px;
    margin-top: calc(88px + 16px);
  `}

  ${(props) => props.theme.media.sm.min`
    padding-left: 16px;
    padding-right: 16px;
  `}

  ${(props) => props.theme.media.lg.max`
    max-width: 1024px;
  `}
`;

export const Button = styled.div`
  display: flex;
  flex: 1;
  color: #fff;
  padding: 0em 1em;
  font-weight: 500;
  border-radius: 4px;
  cursor: pointer;
  line-height: 2.2em;
  justify-content: center;
  align-items: center;
  font-family: 'Roboto';
  background-color: ${(props) => props.theme.brandColor};
  max-width: ${props => props.fullWidth ? 'unset' : '100px'};

  ${(props) =>
    props.disabled &&
    `
    color: #a4a4a4;
    background-color: #e5e5e5;
  `}

  ${(props) =>
    props.secondary &&
    `
    background-color: #fff;
    color: rgb(20, 76, 110);
    box-shadow: inset 0px 0px 0px 2px rgb(20, 76, 110);
  `}

  transition: all 0.15s ease-in-out;

  &:hover {
    opacity: 0.8 !important;
  }

  &:active {
    opacity: 0.5 !important;
  }
`;

export const ButtonLabel = styled.span`
  margin-left: 0.5em;
`;

export const Label = styled.div`
  font-size: 0.9em;

  font-weight: 400;
  margin-bottom: 8px;

  color: rgb(1, 52, 83);
  transition: top 0.1s ease-out;
  font-family: ${Theme.primaryFont};

`;

export const FlexBetween = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const FormsliveLogo = styled.img`
  padding: 1em;
  height: calc(80px - 2em);
  border-radius: 4px;
  background-color: #2A7ABE;
  margin-bottom: 0.5em;
`;

FormsliveLogo.defaultProps = {
  src: `${BASENAME ? '/' : ''}${BASENAME}/img/formslive.png`
}

export const AicsaLogo = styled.img`
  border-style: solid;
  border-width: 1px;
  border-radius: 4px;
  border-color: #d9e4eb;
  height: 80px;
  margin-bottom: 0.5em;
`;

AicsaLogo.defaultProps = {
  src: `${BASENAME ? '/' : ''}${BASENAME}/img/aicsa.png`
}

export const TokenContain = styled.div`

`;

export const CardTitle = styled(Card.Title)`
  margin-bottom: 0.5em;
  background-color: #495e6a0a;
  font-size: 1.2em;
  padding: 0.4em 0.5em;
  color: #18242a;
  border-radius: 2px;
  font-weight: 400;
  box-shadow: 0px 0px 0px 1px #ebeeeec4;
  height: 24px;

  background: #ffffff; /* Old browsers */
  background: -moz-linear-gradient(top, #ffffff 0%, #f9fafa 100%); /* FF3.6-15 */
  background: -webkit-linear-gradient(
    top,
    #ffffff 0%,
    #f9fafa 100%
  ); /* Chrome10-25,Safari5.1-6 */
  background: linear-gradient(
    to bottom,
    #ffffff 0%,
    #f9fafa 100%
  ); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffffff', endColorstr='#f9fafa',GradientType=0 ); /* IE6-9 */
`;

export const EmptyContain = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding-top: 2em;
  padding-bottom: 2em;
  background-color: #fff;
`;

export const EmptyTitle = styled(Card.Title)`
  font-size: 1.5em;
  margin-bottom: 0.5em;
`;

export const ProviderName = styled(Card.Title)`
  font-size: 1em;
  font-weight: 500;
`;

export const ListItemContain = styled.div`
  border-style: solid;
  border-width: 1px;
  padding: 1em;
  border-radius: 4px;
  border-color: #f0f2f2;
`;

export const ProviderSubText = styled.div`
  font-size: 0.875em;
  line-height: 1.5em;
  color: #0009;
`;

export const AICSAAvatar = styled.div`
  background-image: url(${BASENAME ? '/' : ''}${BASENAME}/img/aicsa.png);
  border-radius: 999px;
  width: 48px;
  height: 48px;
  border-style: solid;
  border-width: 1px;
  background-repeat: no-repeat;
  background-size: 70px;
  background-position: -26px center;
  background-color: #263884;
  border-color: #f0f2f2;
`;

export const FormsliveAvatar = styled.div`
  background-image: url(${BASENAME ? '/' : ''}${BASENAME}/img/formslive-logo.png);
  border-radius: 999px;
  width: 48px;
  height: 48px;
  border-style: solid;
  border-width: 1px;
  background-repeat: no-repeat;
  background-size: 65%;
  background-position: 52% center;
  background-color: #2A7ABE;
  border-color: #f0f2f2;
`;
